// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.YqvSPBWPgFesotaV7z4t {
    display: flex;
    flex-direction: column;
    height: 100%;
  }

.ET3zwu7b_E85DsxegX0f {
  text-align: center;
  font-size: 32px;
  font-style: normal;
  font-weight: 510;
  line-height: 32px;
  letter-spacing: -0.264px;
  color: rgb(var(--placeholder-primary));
  margin-bottom: 24px;
  }
  
  .AxDCEtTC57fUDWCy5eB2 {
    font-size: 16px;
    font-style: normal;
    font-weight: 510;
    line-height: 20px;
    letter-spacing: -0.5px;
    color: rgb(var(--placeholder-primary));
    align-self: flex-start;
    text-align: left;

    margin-bottom: 16px;
  }

  .qzUWVVc9b4VeNSyzsXg7 {
    margin: 20px auto 45px auto;
  }
  
  .lW517pNIC2H5E0g59qZY,
  .qVuNeSPD28bQVcpgrkm3 {
    text-align: center;
    line-height: 110%;
    letter-spacing: 0.43px;
  }
  
  .CT3E1pSkHyd3sbEr4DZ1 {
    text-align: center;
    font-family: Inter;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px; /* 128.571% */
    letter-spacing: -0.07px;
    color: rgb(var(--placeholder-secondary));
    margin-bottom: 12px;
  }
  
  .Sg2fIlXxBDZetJaa5xdn {
    display: flex;
    flex-direction: row;
    gap: 8px;
    align-items: center;
  }
  
  .G7KjXraenTqJRv5xHgEg {
    font-size: 28px;
    font-style: normal;
    font-weight: 510;
    line-height: 28px;
    letter-spacing: -0.5px;
    color: rgb(var(--placeholder-secondary));
  }
  
  .lW517pNIC2H5E0g59qZY {
    display: block;
    font-size: 40px;
    font-style: normal;
    font-weight: 510;
    line-height: 32px;
    letter-spacing: -0.5px;
    color: rgb(var(--placeholder-primary));
  }
  
  .qVuNeSPD28bQVcpgrkm3 {
    margin-top: 12px;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px; /* 122.222% */
    letter-spacing: -0.5px;
    color: rgb(var(--placeholder-primary));
  }

  
.O1KG8R6t8fM0OLXTyBuM {
  border-radius: 28px;
  background: rgba(46, 53, 61, 0.40);
  backdrop-filter: blur(28.950000762939453px);
  -webkit-backdrop-filter: blur(28.9px); 
  padding: 16px;
  
  display: flex;
  flex-direction: column;
}

.tL5MskFiZGwBlQ7fEzlB {
  width: 100%;
  padding-top: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  position: relative;
}

.opsp5syRBmVjKRZJJAh6 {
  display: flex;
  align-items: center;
  justify-content: center;
}

.opsp5syRBmVjKRZJJAh6 > svg {
  height: 2px;
  width: 100%;
}

.rrrkqxXe4xPCWLBdClIa{
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: -0.07px;
  color: rgb(var(--placeholder-secondary));
}

.iNezhPZd7SnxE3_P8qBE {
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: -0.5px;
  color: rgb(var(--placeholder-primary));
}`, "",{"version":3,"sources":["webpack://./src/pages/main/buy-modal/invoice/invoice.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;EACd;;AAEF;EACE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,sCAAsC;EACtC,mBAAmB;EACnB;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,sCAAsC;IACtC,sBAAsB;IACtB,gBAAgB;;IAEhB,mBAAmB;EACrB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;;IAEE,kBAAkB;IAClB,iBAAiB;IACjB,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB,EAAE,aAAa;IAChC,uBAAuB;IACvB,wCAAwC;IACxC,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,wCAAwC;EAC1C;;EAEA;IACE,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,sCAAsC;EACxC;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB,EAAE,aAAa;IAChC,sBAAsB;IACtB,sCAAsC;EACxC;;;AAGF;EACE,mBAAmB;EACnB,kCAAkC;EAClC,2CAA2C;EAC3C,qCAAqC;EACrC,aAAa;;EAEb,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,sCAAsC;AACxC","sourcesContent":[".container {\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n  }\n\n.modalTitle {\n  text-align: center;\n  font-size: 32px;\n  font-style: normal;\n  font-weight: 510;\n  line-height: 32px;\n  letter-spacing: -0.264px;\n  color: rgb(var(--placeholder-primary));\n  margin-bottom: 24px;\n  }\n  \n  .detailsHeader {\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 510;\n    line-height: 20px;\n    letter-spacing: -0.5px;\n    color: rgb(var(--placeholder-primary));\n    align-self: flex-start;\n    text-align: left;\n\n    margin-bottom: 16px;\n  }\n\n  .top {\n    margin: 20px auto 45px auto;\n  }\n  \n  .topAmount,\n  .topAmountUsd {\n    text-align: center;\n    line-height: 110%;\n    letter-spacing: 0.43px;\n  }\n  \n  .youSend {\n    text-align: center;\n    font-family: Inter;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 18px; /* 128.571% */\n    letter-spacing: -0.07px;\n    color: rgb(var(--placeholder-secondary));\n    margin-bottom: 12px;\n  }\n  \n  .topAmountWrapper {\n    display: flex;\n    flex-direction: row;\n    gap: 8px;\n    align-items: center;\n  }\n  \n  .topAmountToken {\n    font-size: 28px;\n    font-style: normal;\n    font-weight: 510;\n    line-height: 28px;\n    letter-spacing: -0.5px;\n    color: rgb(var(--placeholder-secondary));\n  }\n  \n  .topAmount {\n    display: block;\n    font-size: 40px;\n    font-style: normal;\n    font-weight: 510;\n    line-height: 32px;\n    letter-spacing: -0.5px;\n    color: rgb(var(--placeholder-primary));\n  }\n  \n  .topAmountUsd {\n    margin-top: 12px;\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 22px; /* 122.222% */\n    letter-spacing: -0.5px;\n    color: rgb(var(--placeholder-primary));\n  }\n\n  \n.info {\n  border-radius: 28px;\n  background: rgba(46, 53, 61, 0.40);\n  backdrop-filter: blur(28.950000762939453px);\n  -webkit-backdrop-filter: blur(28.9px); \n  padding: 16px;\n  \n  display: flex;\n  flex-direction: column;\n}\n\n.infoItem {\n  width: 100%;\n  padding-top: 16px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  position: relative;\n}\n\n.dottedLine {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.dottedLine > svg {\n  height: 2px;\n  width: 100%;\n}\n\n.infoItemLeft{\n  font-family: Inter;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px;\n  letter-spacing: -0.07px;\n  color: rgb(var(--placeholder-secondary));\n}\n\n.infoItemRight {\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px;\n  letter-spacing: -0.5px;\n  color: rgb(var(--placeholder-primary));\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `YqvSPBWPgFesotaV7z4t`,
	"modalTitle": `ET3zwu7b_E85DsxegX0f`,
	"detailsHeader": `AxDCEtTC57fUDWCy5eB2`,
	"top": `qzUWVVc9b4VeNSyzsXg7`,
	"topAmount": `lW517pNIC2H5E0g59qZY`,
	"topAmountUsd": `qVuNeSPD28bQVcpgrkm3`,
	"youSend": `CT3E1pSkHyd3sbEr4DZ1`,
	"topAmountWrapper": `Sg2fIlXxBDZetJaa5xdn`,
	"topAmountToken": `G7KjXraenTqJRv5xHgEg`,
	"info": `O1KG8R6t8fM0OLXTyBuM`,
	"infoItem": `tL5MskFiZGwBlQ7fEzlB`,
	"dottedLine": `opsp5syRBmVjKRZJJAh6`,
	"infoItemLeft": `rrrkqxXe4xPCWLBdClIa`,
	"infoItemRight": `iNezhPZd7SnxE3_P8qBE`
};
export default ___CSS_LOADER_EXPORT___;
